import { render, staticRenderFns } from "./RiskWordForm.vue?vue&type=template&id=0775d3ba&scoped=true"
import script from "./RiskWordForm.vue?vue&type=script&lang=js"
export * from "./RiskWordForm.vue?vue&type=script&lang=js"
import style0 from "./RiskWordForm.vue?vue&type=style&index=0&id=0775d3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0775d3ba",
  null
  
)

export default component.exports